import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import QuestionnaireContext from '../../../../context/questionnaire-context';
import CustomerContext from '../../../../context/customer-context';
import styles from './QuestionnaireHistory.module.css';
import Questionnaire from '../../../../models/Questionnaire';
import { convertDate, convertDateTime, getQuestionnaireName } from './util';

function QuestionnaireHistory() {
  const questionnaireCtx = useContext(QuestionnaireContext);
  const customerCtx = useContext(CustomerContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [sortedQuestionnaire, setSortedQuestionnaire] = useState<Questionnaire[]>([]);

  useEffect(() => {
    const sorted = questionnaireCtx.questionnaires.sort((a, b) => (
      b.questionnaireType.localeCompare(a.questionnaireType) ||
      b.createTimestamp.localeCompare(a.createTimestamp)));
    setSortedQuestionnaire(sorted);
  }, [questionnaireCtx.questionnaires]);

  const handleRowClick = (questionnaire: Questionnaire) => {
    questionnaireCtx.setQuestionnaire(questionnaire);
    navigate('/customer/questionnaire');
  };

  return (
    <div className={styles.container}>
      <div className={styles.customer}>
        <div className={styles.name}>
          {customerCtx.customer.firstName}
          {' '}
          {customerCtx.customer.name}
        </div>
      </div>
      <table className={styles.table}>
        <thead>
        <tr className={styles.row}>
          <th>{t('customer.dashboard.serviceInformation.questionnaireTable.header.filled')}</th>
          <th>{t('customer.dashboard.serviceInformation.questionnaireTable.header.expires')}</th>
          <th>{t('customer.dashboard.serviceInformation.questionnaireTable.header.name')}</th>
        </tr>
        </thead>
        <tbody className={styles.historyTableBody}>
        {sortedQuestionnaire.map(questionnaire => (
          <tr key={uuid()} onClick={() => handleRowClick(questionnaire)} className={styles.row}>
            <td>{convertDateTime(questionnaire.createTimestamp)}</td>
            <td>{convertDate(questionnaire.expirationDate)}</td>
            <td>{getQuestionnaireName(questionnaire.questionnaireType)}</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
}

export default QuestionnaireHistory;
